var map = {
	"./de/": 82,
	"./eu/": 83,
	"./it/": 84,
	"./nl/": 85,
	"./uk/": 22
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;


//////////////////
// WEBPACK FOOTER
// ./shared/config/components/productList ^\.\/.*\/$
// module id = 27
// module chunks = 66